/**
 * LP Bundle Promo -- Brooklyn Bicycle Co.
 * Auto-adds Commuter Bundle + applies META-LP-BUNDLE discount
 * for visitors arriving on a PDP from an LP.
 *
 * Flow:
 *  1. On LP: rewrites /products/{handle} links to include ?promo=lp-bundle
 *  2. On PDP: detects ?promo=lp-bundle, stashes flag in sessionStorage
 *  3. On ATC: adds bundle to cart + silently applies discount, then
 *     dispatches ajaxProduct:added to trigger cart drawer
 *  4. On cart page: removes bundle if qualifying bike is removed
 *
 * Supported bikes: lorimer, roebling
 * Bundle variant ID: 40885522038864 (Commuter Bundle, $54.99)
 */
(function () {
  'use strict';

  var PROMO_KEY = 'lp_bundle_promo';
  var PROMO_VALUE = 'lp-bundle';
  var BUNDLE_VARIANT = 40885522038864;
  var DISCOUNT_CODE = 'META-LP-BUNDLE';
  var BIKE_HANDLES = ['lorimer', 'roebling'];

  /* ---- Helpers ---- */

  function isOnLP() {
    var p = window.location.pathname;
    return (
      p.indexOf('/pages/lorimer-commuter-bike') === 0 ||
      p.indexOf('/pages/lorimer-first-bike') === 0 ||
      p.indexOf('/pages/roebling-commuter-bike') === 0 ||
      p.indexOf('/pages/commuter-bike-roebling') === 0
    );
  }

  function isOnPDP() {
    var p = window.location.pathname;
    for (var i = 0; i < BIKE_HANDLES.length; i++) {
      if (p.indexOf('/products/' + BIKE_HANDLES[i]) === 0) return true;
    }
    return false;
  }

  function isOnCart() {
    return window.location.pathname === '/cart';
  }

  function stashPromo() {
    try { sessionStorage.setItem(PROMO_KEY, PROMO_VALUE); } catch (e) {}
  }

  function hasPromo() {
    try { return sessionStorage.getItem(PROMO_KEY) === PROMO_VALUE; } catch (e) {}
    return false;
  }

  function clearPromo() {
    try { sessionStorage.removeItem(PROMO_KEY); } catch (e) {}
  }

  /**
   * Add the Commuter Bundle to cart, apply the discount code,
   * then open the cart drawer. Returns a Promise.
   */
  function addBundleApplyDiscountAndOpenDrawer(bikeProduct) {
    /* Check cart first -- skip if bundle already present */
    return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var hasBundle = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === BUNDLE_VARIANT) hasBundle = true;
      }
      if (hasBundle) {
        /* Bundle already in cart -- just open drawer */
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: bikeProduct || {} }
        }));
        return;
      }
      /* Add bundle + apply discount */
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: BUNDLE_VARIANT, quantity: 1 }] })
      })
      .then(function () {
        return fetch('/discount/' + DISCOUNT_CODE, {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow'
        });
      })
      .then(function () {
        clearPromo();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: bikeProduct || {} }
        }));
      });
    })
    .catch(function () {
      /* If anything fails, still open the drawer */
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: bikeProduct || {} }
      }));
    });
  }

  /* Expose globally so sticky bars can call it */
  window.__lpBundlePromo = {
    hasPromo: hasPromo,
    addBundleApplyDiscountAndOpenDrawer: addBundleApplyDiscountAndOpenDrawer
  };

  /* ---- STEP 1: Tag LP links ---- */

  function tagLPLinks() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('promo=') !== -1) continue;
      var isBike = false;
      for (var b = 0; b < BIKE_HANDLES.length; b++) {
        if (href.indexOf('/products/' + BIKE_HANDLES[b]) !== -1) { isBike = true; break; }
      }
      if (!isBike) continue;
      links[i].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'promo=' + PROMO_VALUE);
    }
  }

  /* ---- STEP 2: PDP -- detect param, stash ---- */

  function pdpInit() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('promo') === PROMO_VALUE) {
      stashPromo();
    }
    if (hasPromo()) {
      interceptATC();
    }
  }

  /* ---- STEP 3: ATC intercept ---- */

  function interceptATC() {
    var origFetch = window.fetch;

    window.fetch = function () {
      var url = arguments[0];
      var opts = arguments[1] || {};
      var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);

      if (!isCartAdd || !hasPromo()) {
        return origFetch.apply(this, arguments);
      }

      /* If this request contains the bundle variant, let our own
         single-add through but block any add when bundle is already in cart */
      var body = opts.body;
      if (body && typeof body === 'string' && body.indexOf(String(BUNDLE_VARIANT)) !== -1) {
        return origFetch.apply(this, arguments);
      }

      /* Let original ATC complete */
      return origFetch.apply(this, arguments).then(function (response) {
        var cloned = response.clone();
        /* Parse the bike product data from the response */
        cloned.json().then(function (bikeProduct) {
          addBundleApplyDiscountAndOpenDrawer(bikeProduct);
        }).catch(function () {
          addBundleApplyDiscountAndOpenDrawer(null);
        });
        return response;
      });
    };

    /* Patch XHR for themes that use it */
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._lpUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (data) {
      var xhr = this;
      var url = xhr._lpUrl || '';
      var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);

      if (!isCartAdd || !hasPromo()) {
        return origSend.apply(this, arguments);
      }

      if (data && typeof data === 'string' && data.indexOf(String(BUNDLE_VARIANT)) !== -1) {
        return origSend.apply(this, arguments);
      }

      var origOnLoad = xhr.onload;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var bikeProduct = JSON.parse(xhr.responseText);
            addBundleApplyDiscountAndOpenDrawer(bikeProduct);
          } catch (e) {
            addBundleApplyDiscountAndOpenDrawer(null);
          }
        }
        if (origOnLoad) origOnLoad.apply(xhr, arguments);
      };

      return origSend.apply(this, arguments);
    };
  }

  /* ---- STEP 4: Cart guard ---- */

  function cartGuard() {
    function checkAndClean() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasBike = false;
          var bundleQty = 0;

          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            for (var b = 0; b < BIKE_HANDLES.length; b++) {
              if (item.handle === BIKE_HANDLES[b]) { hasBike = true; break; }
            }
            /* 2026-09-03: any bike keeps the bundle (other campaigns give the same bundle on other bikes). */
            if (item.product_type === 'Bicycle') hasBike = true;
            if (item.variant_id === BUNDLE_VARIANT || item.id === BUNDLE_VARIANT) {
              bundleQty = item.quantity;
            }
          }

          /* Remove bundle entirely if no qualifying bike */
          if (bundleQty > 0 && !hasBike) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: String(BUNDLE_VARIANT), quantity: 0 })
            }).then(function () {
              window.location.reload();
            });
          }
          /* Cap bundle at 1 -- prevent multiple free bundles */
          else if (bundleQty > 1) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: String(BUNDLE_VARIANT), quantity: 1 })
            }).then(function () {
              window.location.reload();
            });
          }
        })
        .catch(function () {});
    }

    /* Check on page load */
    setTimeout(checkAndClean, 800);

    /* Re-check after cart modifications */
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var isCartMod = (typeof url === 'string' &&
        (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1));
      var result = origFetch.apply(this, arguments);
      if (isCartMod) {
        result.then(function (r) { setTimeout(checkAndClean, 600); return r; });
      }
      return result;
    };
  }

  /* ---- STEP 5: Cart drawer bundle note ---- */

  var BUNDLE_NOTE_CLASS = 'lp-bundle-free-note';
  var BUNDLE_NOTE_STYLE = 'display:block;font-size:11px;color:#2c3c4c;font-weight:600;' +
    'margin-top:4px;padding:3px 8px;background:#f0ebe4;border-radius:3px;' +
    'line-height:1.3;letter-spacing:0.2px;';

  function getBikeNameFromDrawer() {
    var items = document.querySelectorAll('[data-products] .cart__item-name');
    for (var i = 0; i < items.length; i++) {
      var text = (items[i].textContent || '').toLowerCase();
      for (var b = 0; b < BIKE_HANDLES.length; b++) {
        if (text.indexOf(BIKE_HANDLES[b]) !== -1) {
          /* Title-case the handle */
          return BIKE_HANDLES[b].charAt(0).toUpperCase() + BIKE_HANDLES[b].slice(1);
        }
      }
    }
    return '';
  }

  /* BBC 2026-09-11: only show the "Included FREE" note when the bundle line is
     actually $0 in the drawer (i.e. the discount really applied). */
  function bundleLineIsFree(titleEl) {
    var row = titleEl.closest('.cart__item');
    if (!row) return false;
    var priceEls = row.querySelectorAll('.cart__item-price-col .cart__price');
    var priceEl = null;
    for (var p = 0; p < priceEls.length; p++) {
      if (priceEls[p].className.indexOf('strikethrough') === -1) priceEl = priceEls[p];
    }
    if (!priceEl) return false;
    var digits = (priceEl.textContent || '').replace(/[^0-9]/g, '');
    return digits.length > 0 && parseInt(digits, 10) === 0;
  }

  /* BBC 2026-09-11: idempotent. Only touches the DOM when the note is missing or
     should not be there, so it cannot retrigger its own MutationObserver or loop
     against ready-to-ride-bundle-promo.js. */
  function injectBundleNote() {
    /* Find the bundle line item in the cart drawer */
    var nameLinks = document.querySelectorAll('[data-products] .cart__item-name');
    var bundleTitleEl = null;
    for (var i = 0; i < nameLinks.length; i++) {
      var text = (nameLinks[i].textContent || '').toLowerCase();
      if (text.indexOf('commuter bundle') !== -1 ||
          text.indexOf('riding essentials') !== -1 ||
          text.indexOf('commuter accessories') !== -1) {
        bundleTitleEl = nameLinks[i];
        break;
      }
    }

    var titleWrap = bundleTitleEl ? bundleTitleEl.closest('.cart__item-title') : null;
    var bikeName = titleWrap ? getBikeNameFromDrawer() : '';
    var show = !!(titleWrap && bikeName && bundleLineIsFree(bundleTitleEl));

    if (!show) {
      var mine = document.querySelectorAll('.' + BUNDLE_NOTE_CLASS);
      for (var e = 0; e < mine.length; e++) mine[e].parentNode.removeChild(mine[e]);
      return;
    }

    if (!titleWrap.querySelector('.lp-bundle-free-note, .spring-bundle-free-note, .rtr-bundle-free-note')) {
      var note = document.createElement('span');
      note.className = BUNDLE_NOTE_CLASS;
      note.setAttribute('style', BUNDLE_NOTE_STYLE);
      note.textContent = 'Included FREE with your ' + bikeName;
      titleWrap.appendChild(note);
    }

    /* Hide the theme upsell card -- it offers the same bundle at full price */
    var upsellCards = document.querySelectorAll('cart-upsell, .upsell__container');
    for (var u = 0; u < upsellCards.length; u++) {
      upsellCards[u].style.display = 'none';
    }
  }

  /* Re-show the upsell card if the free bundle is NOT in cart */
  function restoreUpsellIfNeeded() {
    var nameLinks = document.querySelectorAll('[data-products] .cart__item-name');
    var hasBundle = false;
    for (var i = 0; i < nameLinks.length; i++) {
      var text = (nameLinks[i].textContent || '').toLowerCase();
      if (text.indexOf('commuter bundle') !== -1 ||
          text.indexOf('riding essentials') !== -1 ||
          text.indexOf('commuter accessories') !== -1) {
        hasBundle = true;
        break;
      }
    }
    if (!hasBundle) {
      var upsellCards = document.querySelectorAll('cart-upsell, .upsell__container');
      for (var u = 0; u < upsellCards.length; u++) {
        upsellCards[u].style.display = '';
      }
    }
  }

  function observeBundleNote() {
    /* Inject on every cart drawer re-render */
    var productsEl = document.querySelector('[data-products]');
    if (productsEl && !productsEl.__lpBundleNoteObs) {
      productsEl.__lpBundleNoteObs = true;
      new MutationObserver(function () {
        setTimeout(function () { injectBundleNote(); restoreUpsellIfNeeded(); }, 50);
      }).observe(productsEl, { childList: true, subtree: true });
    }

    /* Also inject on drawer open (class change on #CartDrawer) */
    var drawer = document.getElementById('CartDrawer');
    if (drawer && !drawer.__lpBundleDrawerObs) {
      drawer.__lpBundleDrawerObs = true;
      new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          if (mutations[m].attributeName === 'class') {
            setTimeout(injectBundleNote, 100);
          }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    /* Also listen for the ajaxProduct:added event */
    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(injectBundleNote, 300);
    });

    /* Initial injection in case drawer is already open */
    setTimeout(injectBundleNote, 500);
  }

  /* ---- INIT ---- */

  function init() {
    if (isOnLP()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tagLPLinks);
      } else {
        tagLPLinks();
      }
      new MutationObserver(function () { tagLPLinks(); })
        .observe(document.body || document.documentElement, { childList: true, subtree: true });
    }

    if (isOnPDP()) {
      pdpInit();
    }

    if (isOnCart()) {
      cartGuard();
    }

    /* Bundle note runs on any page -- the cart drawer can open anywhere */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeBundleNote);
    } else {
      observeBundleNote();
    }
  }

  init();
})();
